import { AlertPopup } from './AlertPopup'
import { BeforeLeavePopup } from './BeforeLeavePopup'
import { SaveCriteriaPopup } from './saveCriteriaPopup'

export const ScreeningPopup = () => {
  return (
    <>
      <AlertPopup />
      <SaveCriteriaPopup />
      <BeforeLeavePopup />
    </>
  )
}
